export default "__VITE_ASSET__BK3n33C9__"